import { createTheme } from "@mui/material/styles";
import COLOR_PALETTE from "./color-palete";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: COLOR_PALETTE.White },
    secondary: { main: COLOR_PALETTE.Pink },
    background: { default: "#0e052e", paper: "rgba(255,255,255,0.05)" },
  },
  typography: {
    fontFamily: '"Roboto", sans-serif',
    h3: { fontWeight: 700, letterSpacing: "-0.5px" },
    h4: { fontWeight: 700, letterSpacing: "-0.3px" },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 500 },
    body1: { fontWeight: 400, lineHeight: 1.75 },
    body2: { fontWeight: 300, lineHeight: 1.65 },
    caption: { fontWeight: 300 },
    overline: { fontWeight: 500 },
    button: { fontWeight: 500, letterSpacing: "0.8px" },
  },
  shape: { borderRadius: 12 },
});

export default theme;
